import { style } from '@vanilla-extract/css';

export const loginElement = style({
  margin: '0 auto',
});

export const input = style({
  border: 'none',
  outline: 'none',
  // tailwind adds input[type=email] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-background-color) !important',
  '::placeholder': {
    color: 'var(--placeholder-color)',
    fontSize: 'var(--placeholder-font-size)',
  },
});

export const icon = style({});
